import React from 'react';
/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  a,
  f,
  ls,
  BoxC,
  GridC,
  HtyC,
//  IptC,
//  LblC,
//  MsgC,
  SrlC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as SrlC from "./_ccbSrlC";
import * as GridC from "./_cccGridC";
import * as HtyC from "./_ccmHtyC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ht from './_ht';

/*
import * as icm from './icm';
import * as ict from './ict';
import * as icv from './icv';
*/

//import * as IccFtrBtn from './IccvBtn';

//import * as icvI15___Mz from './icvI15___Mz';
import * as icvI15___Ci from './icvI15___Ci';

//let $vsn = -1;
//let $pcrs = [] as ht.ls;

export const N = (pz: {
  sPz: ht.dz,
}) => {

//  const _udtThis = ls.udtThis();

//hf.l(`icvI15S10Co 45: here`)
  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'bdyCmnz',
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'barFtnStfz',
          boxStlz: a(`mb/2`),
          lineCs: [
            {
              cellCs: [
                {
                  oClds: []
                },
                {
                  oClds: []
                },
                {
                  oClds: [
                    cr.c(HtyC.N, {
                      key: -10,
                      sPz: pz.sPz,
                      cz: {
                        elm: 'i15r',
//                        _fst: pz.sPz.crt.i15r_fst,
                      }
                    })
                  ]
                },
              ]
            }
          ]
        }),

        cr.c(BoxC.N, {
          key: -20,
          abtType: 'cttCmnz',
          oClds: [

            cr.c(SrlC.V, {
              key: -20,
              abtType: 'cttCmnz',
              oClds: [

                cr.c(icvI15___Ci.D, {
                  key: -10,
                  sPz: pz.sPz,
                })

              ],
            }),

            cr.c(icvI15___Ci.B, {
              key: -30,
              sPz: pz.sPz,
              cz: {
                lblz: pz.sPz.crt.lblz,
                sc: 'gn7',
              },
            })

          ]
        })

      ]
    })
  );
};
